module.exports = __webpack_public_path__ + "static/lframe-financial-hardship-1b841b8b89da01ccd5a8693e5c7e602b.png";